import React from "react";

interface Props {}

export const AssetsTiles: React.FC<Props> = () => {
  return (
    <>
      <div className="pickaxe" style={{ gridColumn: "7", gridRow: "4" }} />
      <div
        className="pickaxe"
        style={{
          gridColumn: "19",
          gridRow: "4",
          top: "10px",
          left: "-25px",
        }}
      />
      <div
        className="pickaxe"
        style={{ gridColumn: "19", gridRow: "13", left: "15px" }}
      />
      <div
        className="pickaxe"
        style={{ gridColumn: "6", gridRow: "12" }}
      />
      <div
        className="shovel-lie"
        style={{
          gridColumn: "7",
          gridRow: "3",
          top: "20px",
          left: "15px",
        }}
      />
      <div
        className="shovel"
        style={{ gridColumn: "2", gridRow: "12", left: "-10px" }}
      />
      <div
        className="shovel"
        style={{ gridColumn: "16", gridRow: "12", top: "-30px" }}
      />
      <div
        className="shovel"
        style={{ gridColumn: "11", gridRow: "7", top: "20px" }}
      />
      <div
        className="grave"
        style={{
          gridColumn: "8",
          gridRow: "4",
          top: "-5px",
          left: "20px",
        }}
      />
      <div
        className="threebox-black-lie"
        style={{
          gridColumn: "9",
          gridRow: "4",
          top: "10px",
          left: "20px",
        }}
      />
      <div
        className="threebox-black"
        style={{
          gridColumn: "19",
          gridRow: "7",
          top: "0px",
          right: "5px",
        }}
      />
      <div
        className="mark"
        style={{
          gridColumn: "19",
          gridRow: "4",
          top: "0px",
          right: "5px",
        }}
      />
      <div
        className="mark"
        style={{
          gridColumn: "19",
          gridRow: "11",
          top: "0px",
          right: "5px",
        }}
      />
      <div
        className="grass"
        style={{
          gridColumn: "19",
          gridRow: "11",
          top: "12px",
          right: "12px",
        }}
      />
      <div
        className="mark"
        style={{
          gridColumn: "10",
          gridRow: "4",
          top: "-22px",
          left: "15px",
        }}
      />
      <div
        className="mark"
        style={{ gridColumn: "7", gridRow: "7", top: "0px", left: "-5px" }}
      />
      <div
        className="grass"
        style={{
          gridColumn: "7",
          gridRow: "7",
          top: "12px",
          right: "5px",
        }}
      />
      <div
        className="mark"
        style={{
          gridColumn: "7",
          gridRow: "11",
          top: "0px",
          left: "-5px",
        }}
      />
      <div
        className="threebox-orange"
        style={{
          gridColumn: "10",
          gridRow: "7",
          top: "-10px",
          left: "-5px",
        }}
      />
      <div
        className="manybox"
        style={{
          gridColumn: "10",
          gridRow: "10",
          top: "20px",
          right: "25px",
        }}
      />
      <div
        className="block"
        style={{
          gridColumn: "10",
          gridRow: "11",
          top: "-8px",
          right: "22px",
        }}
      />
      <div
        className="three-big-box"
        style={{
          gridColumn: "10",
          gridRow: "12",
          top: "12px",
          right: "35px",
        }}
      />
      <div
        className="trail-start"
        style={{ gridColumn: "3", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "4", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "5", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "6", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "7", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "8", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "9", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "10", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "11", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "12", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "13", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "14", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "15", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "16", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-line"
        style={{ gridColumn: "17", gridRow: "8", top: "25px" }}
      />
      <div
        className="trail-end"
        style={{ gridColumn: "18", gridRow: "8", top: "25px" }}
      />
      <div
        className="blackstone"
        style={{
          gridColumn: "2",
          gridRow: "8",
          top: "22px",
          left: "14px",
        }}
      />

      <div
        className="blackstone"
        style={{
          gridColumn: "19",
          gridRow: "8",
          top: "22px",
          left: "-14px",
        }}
      />
      <div
        className="blackbox"
        style={{
          gridColumn: "6",
          gridRow: "8",
          top: "-30px",
          right: "20px",
        }}
      />
      <div
        className="redmushroom"
        style={{
          gridColumn: "6",
          gridRow: "8",
          top: "-20px",
          right: "44px",
        }}
      />
      <div
        className="purplemushroom"
        style={{
          gridColumn: "8",
          gridRow: "13",
          top: "10px",
          right: "10px",
        }}
      />
      <div
        className="purplemushroom"
        style={{
          gridColumn: "8",
          gridRow: "4",
          top: "10px",
          right: "30px",
        }}
      />
      <div
        className="purplemushroom"
        style={{
          gridColumn: "16",
          gridRow: "11",
          top: "20px",
          left: "20px",
        }}
      />
      <div
        className="purplemushroom"
        style={{
          gridColumn: "10",
          gridRow: "7",
          top: "15px",
          left: "15px",
        }}
      />
      <div
        className="orangemushroom"
        style={{
          gridColumn: "8",
          gridRow: "13",
          top: "-5px",
          right: "20px",
        }}
      />
      <div
        className="orangemushroom"
        style={{
          gridColumn: "19",
          gridRow: "10",
          top: "-5px",
          right: "10px",
        }}
      />
      <div
        className="orangemushroom"
        style={{
          gridColumn: "12",
          gridRow: "12",
          top: "-10px",
          right: "0px",
        }}
      />
      <div
        className="orangemushroom"
        style={{
          gridColumn: "13",
          gridRow: "4",
          top: "-10px",
          right: "0px",
        }}
      />
      <div
        className="orangemushroom"
        style={{
          gridColumn: "4",
          gridRow: "7",
          top: "20px",
          right: "0px",
        }}
      />
      <div
        className="redmushroom"
        style={{
          gridColumn: "8",
          gridRow: "13",
          top: "15px",
          right: "50px",
        }}
      />
      <div
        className="whitestone"
        style={{
          gridColumn: "14",
          gridRow: "11",
          top: "22px",
          right: "0px",
        }}
      />
      <div
        className="whitestone"
        style={{
          gridColumn: "12",
          gridRow: "9",
          top: "-5px",
          right: "5px",
        }}
      />
      <div
        className="whitestone"
        style={{
          gridColumn: "7",
          gridRow: "6",
          top: "10px",
          left: "10px",
        }}
      />
      <div
        className="whitestone-small"
        style={{
          gridColumn: "9",
          gridRow: "5",
          top: "-10px",
          left: "-10px",
        }}
      />
      <div
        className="whitestone-small"
        style={{
          gridColumn: "7",
          gridRow: "12",
          top: "-10px",
          left: "-10px",
        }}
      />
      <div
        className="whitestone-small"
        style={{
          gridColumn: "7",
          gridRow: "12",
          top: "-20px",
          left: "0px",
        }}
      />
    </>
  );
};
